module.exports = __webpack_public_path__ + "static/media/Kareem_logo1.fed849f4.jpg";